// @flow

import * as React from "react"
import { intersperse } from "ramda"
import { Link } from "gatsby"

type Frontmatter = {
    title: string,
    date: string,
    author: string,
    tags: Array<string>,
    description?: string,
    image?: string,
}

export type BlogPreview = {
    excerpt: string,
    frontmatter: Frontmatter,
    fields: Object,
}

export default ({ excerpt, frontmatter, fields }: BlogPreview) => {
    const title = frontmatter.title || fields.slug

    return (
        <li key={fields.slug}>
            <article
                itemScope
                className="post-list-item"
                itemType="http://schema.org/Article">
                <header>
                    <h2>
                        <Link to={fields.slug} itemProp="url">
                            <span itemProp="headline">{title}</span>
                        </Link>
                    </h2>
                    <p>
                        <small>
                            <span style={{ marginRight: 10 }}>
                                <i className="fa fa-calendar" />{" "}
                                {frontmatter.date}
                            </span>
                            <span style={{ marginRight: 10 }}>
                                <i className="fa fa-user" />{" "}
                                {frontmatter.author}
                            </span>
                            <span>
                                <i className="fa fa-tags" />{" "}
                                {intersperse(
                                    ", ",
                                    frontmatter.tags.map((t) => (
                                        <Link
                                            key={t}
                                            to={`/tags/${encodeURIComponent(
                                                t
                                            )}`}>
                                            {t}
                                        </Link>
                                    ))
                                )}
                            </span>
                        </small>
                    </p>
                </header>
                {frontmatter.image ? (
                    <figure className="center-align">
                        <img
                            src={frontmatter.image}
                            alt={title}
                            style={{ maxWidth: "100%" }}
                        />
                        <figcaption className="center-align">
                            <small style={{ color: "#5a5a5a" }}>
                                {title} - <i>{frontmatter.author}</i>
                            </small>
                        </figcaption>
                    </figure>
                ) : null}
                <section>
                    <p
                        dangerouslySetInnerHTML={{
                            __html: frontmatter.description || excerpt,
                        }}
                        itemProp="description"
                    />
                </section>
                <br />
                <p>
                    <Link
                        to={fields.slug}
                        itemProp="url"
                        className="btn btn-flat green white-text">
                        Continue reading
                    </Link>
                </p>
                <div
                    className="center"
                    style={{
                        width: "50%",
                        margin: "75px auto",
                        borderBottom: "solid 1px #ccc",
                    }}
                />
            </article>
        </li>
    )
}
